import countries from './countries'

export function getCountryByAlpha2 (aplha2, strict) {
  if (strict && (aplha2 == null || aplha2.length !== 2 || typeof aplha2 !== 'string')) throw new Error('Invalid params: aplha2')

  const country = countries.find(ele => ele.a2 === aplha2)

  return country
}
